import React, { Component } from "react";
import { ErrorOutline } from "@mui/icons-material";
import "../../assets/styles/errorPages.css";

export class PageNotFound extends Component {
  render() {
    return (
      <div className="error_page_container">
        <div className="error_page_content">
          <h1>
            <ErrorOutline /> Page not found.
          </h1>
          <div>The page you are trying to access could not be found.</div>
        </div>
      </div>
    );
  }
}
